// src/lib/tripHandlers.ts
import { Latitude, Longitude, Coordinates } from "@/types/distance.types";
import { Vehicle } from "@/types/vehicle.types";
import { Stops } from "@/types/trip.types";
import { fetchReverseGeocode } from "@/services/geocodeService";
import { showPopup } from "@/components/warnings/Popup";

export type SetStopsFn = (updater: (prev: Stops) => Stops) => void;
export type SetShouldRecalculateFn = (v: boolean) => void;
export type ClearTripResultsFn = () => void;

export function createClearStopResults(
  clearStop: (index: number) => void,
  clearTripResults: ClearTripResultsFn,
  setEmissionsLoaded: (val: Record<string, boolean>) => void
) {
  return (index: number) => {
    clearStop(index);
    clearTripResults();
    setEmissionsLoaded({ Food: false, Travel: false, Appliance: false });
  };
}

export function createClearTrip(
  clearTripInputs: () => void,
  clearTripResults: ClearTripResultsFn
) {
  return () => {
    clearTripInputs();
    clearTripResults();
  };
}

export function createHandleMarkerDragEnd(
  setStops: SetStopsFn,
  setShouldRecalculate: SetShouldRecalculateFn,
) {
  return async (newPos: [Latitude, Longitude], index: number): Promise<void> => {
    try {
      const result = await fetchReverseGeocode(newPos[0], newPos[1]);

      if (!result) return;

      const newAddress = result.address
      setStops(prev => {
        const newStops = [...prev];
        newStops[index] = { address: newAddress, coords: {latitude: newPos[0], longitude: newPos[1]} as Coordinates };
        return newStops;
      });
      setShouldRecalculate(true);
    } catch {
      showPopup(
        "Unexpected Error",
        "An unexpected error has occured."
      )
    }
  };
}

export function createPlanTripInvoker(
  planTrip: (stops: Stops, vehicle: Vehicle) => Promise<void> | void,
  setLoading: (v: boolean) => void
) {
  return async (stops: Stops, vehicle: Vehicle) => {
    setLoading(true);
    try {
      await planTrip(stops, vehicle);
    } finally {
      setLoading(false);
    }
  };
}
